import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isVacio } from '../../utils/utilidades';

export interface Data {
  label: string;
  valor: number | string;
  subValor?: number;
  subUnidadMedida?: string;
}
@Component({
  selector: 'app-card-dashboard-no-chart',
  templateUrl: './card-dashboard-no-chart.component.html',
  styleUrls: ['./card-dashboard-no-chart.component.scss']
})
export class CardDashboardNoChartComponent implements OnInit {

  @Input() titulo: string;
  @Input() tituloClass: string;
  @Input() data: Data[] = [];
  @Input() iconClass: string;
  @Input() iconContainerClass: string;
  @Input() mostrarBotonDetalle: boolean;
  @Input() textoBotonDetalle: string;

  @Output() clickDetalle = new EventEmitter();

  isVacio = isVacio;

  constructor() { }

  ngOnInit() {
  }

  isNumber(valor) {
    return typeof valor === 'number';
  }

}

